import { render, staticRenderFns } from "./NewCustomerDiagnose.vue?vue&type=template&id=5dc4f884&"
import script from "./NewCustomerDiagnose.vue?vue&type=script&lang=js&"
export * from "./NewCustomerDiagnose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports